import { render, staticRenderFns } from "./GitlabOauthScreen.vue?vue&type=template&id=7971fcff"
import script from "./GitlabOauthScreen.vue?vue&type=script&lang=js"
export * from "./GitlabOauthScreen.vue?vue&type=script&lang=js"
import style0 from "./GitlabOauthScreen.vue?vue&type=style&index=0&id=7971fcff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports